'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _reactAutosuggest = require('react-autosuggest');

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _airlines = require('utils/airlines');

var _airlines2 = _interopRequireDefault(_airlines);

var _reactIsolatedScroll = require('react-isolated-scroll');

var _reactIsolatedScroll2 = _interopRequireDefault(_reactIsolatedScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ComboboxInput: {
        displayName: 'ComboboxInput'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/forms/ComboboxInput.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

// var isMobile = require('ismobilejs');

var getSuggestions = function getSuggestions(value) {
    var inputValue = value.trim().toLowerCase();

    // Single OR filter (previously two filters were concat'd) to avoid duplicate rows 
    // When the query matches both an airline's code and name (e.g. "tez" → code TEZ + name TezJet).
    return inputValue.length === 0 ? [] : _airlines2.default.filter(function (airline) {
        return airline.code.toLowerCase().includes(inputValue) || airline.name.toLowerCase().includes(inputValue);
    });
};

var getSuggestionValue = function getSuggestionValue(suggestion) {
    return suggestion.code;
};

var renderSuggestion = function renderSuggestion(suggestion) {
    return _react3.default.createElement(
        'div',
        null,
        suggestion.name,
        ' - ',
        suggestion.code
    );
};

var shouldRenderSuggestions = function shouldRenderSuggestions() {
    return true;
};

function renderSuggestionsContainer(_ref) {
    var containerProps = _ref.containerProps,
        children = _ref.children;
    var ref = containerProps.ref,
        restContainerProps = (0, _objectWithoutProperties3.default)(containerProps, ['ref']);

    var callRef = function callRef(isolatedScroll) {
        if (isolatedScroll !== null) {
            ref(isolatedScroll.component);
        }
    };

    return _react3.default.createElement(
        _reactIsolatedScroll2.default,
        (0, _extends3.default)({ ref: callRef }, restContainerProps),
        children
    );
}

var ComboboxInput = _wrapComponent('ComboboxInput')(function (_Component) {
    (0, _inherits3.default)(ComboboxInput, _Component);

    function ComboboxInput() {
        var _ref2;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ComboboxInput);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ComboboxInput.__proto__ || (0, _getPrototypeOf2.default)(ComboboxInput)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
            value: _this.props.value ? _this.props.value : '',
            suggestions: []
        }, _this.onChange = function (event, _ref3) {
            var newValue = _ref3.newValue;

            _this.setState({
                value: newValue
            });
        }, _this.onSuggestionsFetchRequested = function (_ref4) {
            var value = _ref4.value;

            _this.setState({
                suggestions: value ? getSuggestions(value) : _airlines2.default.slice(0, 10)
            });
        }, _this.onSuggestionsClearRequested = function () {
            _this.setState({
                suggestions: []
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ComboboxInput, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                value = _state.value,
                suggestions = _state.suggestions;

            // Autosuggest will pass through all these props to the input element

            var inputProps = (0, _extends3.default)({}, this.props, {
                value: value,
                onChange: this.onChange
            });

            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_reactAutosuggest2.default, {
                    id: this.props.id,
                    suggestions: suggestions,
                    onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
                    onSuggestionsClearRequested: this.onSuggestionsClearRequested,
                    getSuggestionValue: getSuggestionValue,
                    renderSuggestion: renderSuggestion,
                    inputProps: inputProps,
                    renderSuggestionsContainer: renderSuggestionsContainer,
                    shouldRenderSuggestions: shouldRenderSuggestions,
                    focusInputOnSuggestionClick: false
                })
            );
        }
    }]);
    return ComboboxInput;
}(_react2.Component));

exports.default = ComboboxInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/ComboboxInput.js
// module id = 1338
// module chunks = 0